import React, { Component } from 'react';
import './aboutpage.css'

class AboutPage extends Component {

  render() {

    return (
          <p className="tekstiapukkaa">
          Hei,
          <br/>
          Hienoa, että olemme saaneet sinut mukaan testaamaan
          <br/>
          protopalveluamme, jossa ryhmänne saa helposti jaettua
          <br/>
          keskenään ryhmänne riistakameroiden kuvat.
          <br/>
          Ethän jaa saamaasi osoitetta eteen päin tässä kohtaa protoilua, kiitos.
          <br/>
          t, ylläpitäjät

          </p>
    );
  }
}
export default AboutPage;



// WEBPACK FOOTER //
// ./src/aboutpage.js